module.exports = __webpack_public_path__ + "static/media/avatar-06.4d433825.svg";